<button mat-flat-button type="button" class="kp-image-upload-button" (click)="uploadClick()" *ngIf="!isDraggingOver">
  <mat-icon>upload</mat-icon>
  {{ 'UI.IMAGE_UPLOAD.SELECT_IMAGE' | transloco }}
</button>

<input
  hidden
  type="file"
  accept="image/jpeg, image/png, image/webp"
  data-test="image-upload-input"
  #fileInput
  (change)="onFileInputChange($event)"
/>
<div class="absolute inset-0 grid place-content-center justify-items-center pointer-events-none" *ngIf="isDraggingOver">
  <mat-icon class="s-12">upload</mat-icon>
  {{ 'UI.IMAGE_UPLOAD.DROP_IMAGE_TO_LOAD' | transloco }}
</div>
